import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiFetch, DPP_BASE_URL } from '../dppApi';
import EstatePlanner from './EstatePlanner';
import ExecutorEstate from './ExecutorEstate';
import '../App.css';

const bloomMark = process.env.PUBLIC_URL + '/BloomFavicon.png';

// The view reached from an owner's estate share link (/estate/:token). The token
// in the URL is the access credential (scoped) — no login. Its ROLE decides what
// renders:
//   • lawyer   → the SAME editable Estate plan as the owner's My Account
//                (<EstatePlanner>), for setting designations / attaching the will.
//   • executor → the exercise flow (<ExecutorEstate>): locked until a death
//                certificate is uploaded, then exercise the will.
const EstateShared = () => {
    const { token } = useParams();
    const base = `/api/user/estate/shared/${token}`;

    // A light probe just to learn the grant's role (and surface an invalid/expired
    // link). Each child then manages its own reads/writes.
    const [meta, setMeta] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        let alive = true;
        apiFetch(base)
            .then(d => { if (alive) setMeta(d); })
            .catch(e => { if (alive) setError(e.message); });
        return () => { alive = false; };
    }, [base]);

    const api = {
        get: () => apiFetch(base),
        saveDesignation: (body) => apiFetch(`${base}/designation`, { method: 'PUT', body }),
        clearDesignation: (pid) => apiFetch(`${base}/designation/${pid}`, { method: 'DELETE' }),
        saveExecutor: (body) => apiFetch(`${base}/executor`, { method: 'PUT', body }),
        uploadWill: (form) => apiFetch(`${base}/will`, { method: 'POST', body: form, isForm: true }),
    };

    const isExecutor = meta?.role === 'executor';

    return (
        <div className="dpp-page">
            <div className="collection-topbar collection-topbar--solo">
                <div className="collection-topbar-brand">
                    <img className="dpp-brand-mark" src={bloomMark} alt="Bloom" />
                    <h1 className="collection-topbar-title">Estate plan</h1>
                </div>
            </div>

            <div className="settings-wrap settings-wrap--solo dpp-card">
                <div className="settings-body">
                    {error && <p className="dpp-error">{error}</p>}
                    {!error && !meta && <p className="collection-status collection-status--flush">Loading…</p>}
                    {meta && isExecutor && <ExecutorEstate token={token} />}
                    {meta && !isExecutor && (
                        <EstatePlanner
                            api={api}
                            showShare={false}
                            title={null}
                            subtitle="Shared with you to help set up this estate. Your changes are saved."
                            passportHref={p => `${DPP_BASE_URL}/jewellery/${p.qr_code_id}?page=4&estate_token=${token}`} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default EstateShared;
